import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import {
	getCarAgentListing,
} from './../../../../Redux/Actions/UserAction';

export const CarAgentCommonHeader = () => {
	const home = useSelector(state => state.home);
	const CarAgentsList = home?.CarAgentsList;

	const dispatch = useDispatch();

	useEffect(() => {
		console.log('this is the list ', CarAgentsList);
		if (CarAgentsList === undefined) {
			dispatch(getCarAgentListing(sessionStorage.getItem('BusinessId')));
		}
	}, []);

    console.log('CarAgentsList', CarAgentsList);

	return (
		<div>
			{CarAgentsList !== undefined &&
			CarAgentsList !== [] &&
			CarAgentsList?.length !== 0 ? (
				CarAgentsList.map(item => {
					return (
						<div class='sp-banner'>
							<ImageGallery
								items={item?.businessMedia?.map(item => {
									if (item?.mediaType === 'BANNER') {
										return { original: item?.media?.path, originalHeight: '400px', };
									} else {
										return {
											original:
												'assets/images/service-provider/car-dealers/banner-a.jpg',
										};
									}
								})}
								class='img-fluid sp-banner-img'
								showThumbnails={false}
							/>

							{/* <img
								src='assets/images/service-provider/car-dealers/banner-a.jpg'
								alt=''
								class='img-fluid sp-banner-img'
							/> */}
							<div class='sp-logo'>
								<div class='line-a'>
								{item?.businessMedia?.map(item => {
										if (item?.mediaType === 'LOGO') {
											return (
												<img
													src={item?.media?.path}
													// src='assets/images/service-provider/car-dealers/logo.jpg'
													alt=''
													class='img-fluid'
												/>
											);
										}
									})}
								</div>
								<div class='line-b'>{item?.carDealerName}</div>
							</div>
						</div>
					);
				})
			) : (
				<div class='sp-banner'>
					<img
						src='assets/images/service-provider/car-dealers/banner-a.jpg'
						alt=''
						class='img-fluid sp-banner-img'
					/>
					<div class='sp-logo'>
						<div class='line-a'>
							<img
								src='assets/images/service-provider/car-dealers/logo.jpg'
								alt=''
								class='img-fluid'
							/>
						</div>
						<div class='line-b'>Car Agent business Name</div>
					</div>
				</div>
			)}
		</div>
	);
};
